import Vue from 'vue';
import App from './App';
import router from './router';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import weui from 'weui.js';
import 'weui';
Vue.prototype.$weui = weui;

import 'font-awesome/css/font-awesome.min.css';

// import 'bootstrap/dist/js/bootstrap'
import 'jquery'
import 'bootstrap/dist/css/bootstrap.css'

import 'bootstrap-icons/font/bootstrap-icons.css'

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;

import moment from "moment";

Vue.prototype.$moment = moment;

import store from "./store";
/*import Mock from 'mockjs' // 引入 Mock.js
import './mock/mock.js' // 引入 Mock 数据

Vue.prototype.$mock = Mock // 将 Mock.js 注册到 Vue 对象中*/


Date.prototype.Format = function (fmt) { //author: meizz
  let o = {
      "M+": this.getMonth() + 1, //月份
      "d+": this.getDate(), //日
      "h+": this.getHours(), //小时
      "m+": this.getMinutes(), //分
      "s+": this.getSeconds(), //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
  if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

/*router.beforeEach(function(to, from, next) {
  if (to.meta.needLogin) {
    //页面是否登录
    if (sessionStorage.getItem("login")) {
      //本地存储中是否有token(uid)数据
      next(); //表示已经登录
    } else {
      //next可以传递一个路由对象作为参数 表示需要跳转到的页面
      next({
        name: "homePage"
      });
    }
  } else {
    //表示不需要登录
    next(); //继续往后走
  }
});*/




// WEBPACK FOOTER //
// ./src/main.js